var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show",attrs:{"id":"page-loader"}},[_c('div',{staticClass:"content-loader-inner"},[_c('div',{staticClass:"spinner"}),_c('img',{attrs:{"src":_vm.LeLogo,"alt":_vm.LeLogo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }